import { Link } from "react-router-dom";
import { ALPHA3_PORTABLE } from "../download";

export function HomePage() {
  return (
    <>
      <p className="mono-label">Minecraft PvP analytics</p>
      <h1 className="display">
        See the fight.
        <br />
        <span className="dim">Trust the data.</span>
      </h1>
      <p className="lede">
        PVPInsight is a Windows desktop recorder for Fabric Minecraft PvP. Capture stays on your
        machine. Review, coaching, and history run locally. Sync is optional.
      </p>
      <div className="cta-row">
        <Link className="btn" to="/download">
          Download portable ZIP
        </Link>
        <Link className="btn ghost" to="/features">
          Features
        </Link>
      </div>
      <p className="note">
        Current public channel: <strong>{ALPHA3_PORTABLE.version}</strong> ({ALPHA3_PORTABLE.buildId}
        ). Setup installer temporarily unavailable — portable ZIP only.
      </p>
      <div className="grid-2">
        <article className="card">
          <h3>Local-first</h3>
          <p>Fight telemetry and history live on your PC. Nothing uploads unless you opt in.</p>
        </article>
        <article className="card">
          <h3>Evidence-backed</h3>
          <p>Unresolved stays unresolved. Missing measurements are never filled with zeros.</p>
        </article>
        <article className="card">
          <h3>NethPot-focused</h3>
          <p>Built around NethPot duels. Other modes may record; coaching depth varies by kit.</p>
        </article>
        <article className="card">
          <h3>Signed updates</h3>
          <p>In-app updates use Ed25519-signed manifests on updates.pvpinsight.com.</p>
        </article>
      </div>
    </>
  );
}
